export function isHTMLInputElement(
  element: HTMLElement | HTMLInputElement | null
): element is HTMLInputElement {
  return element !== null && element.tagName === 'INPUT'
}
